import SnackBarApi from "./api";
//vue plugin
export const snackbar = {
  install(Vue, options = {}) {
    Vue.prototype.$vsnackbar = SnackBarApi(options);
  }
};

//function
export default SnackBarApi;
